const namespaced = true;

const defaultState = () => {
  return {
    step: 1,
    show:false,
    result:0
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_STEP(state, step) {
    state.step = step;
  },
  SET_SHOW(state,show){
    state.show = show;
  },
  SET_RESULT(state,result){
    state.result = result
  }
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
